import { Doctor } from "./doctor";
import { ExtraParameter } from "./extraParameter";
import { Plan } from "./plan";
import { SatisfactionSurveyQuestion } from "./satisfactionSurveyQuestion";

export class Provider {
  id: string;
  name: string // ej Prevencion Salud
  serviceObjectName: string // ej PSAffiliateService
  auth0ConnectionName: string // ej ps-sancor
  updatedAt: string = "";
  modelObjectName: string;
  billingEmailAddress: string;
  fileSharing: boolean;
  minAge:Number;
  prescriptionModel:string;
  prescriptionFooterModel:string;
  prescriptionFooterColor:string;
  prescriptionPillColor:string;
  assistanceCertificateModel: string;
  prescriptionModelMail:string;
  requiresHealthInsuranceInformation:boolean;
  supportsPrescription:boolean;
  supportsMedicalOrder:boolean;
  supportsMedicalCareRecord:boolean;
  language:string
  country:string
  timezone:string
  doctors:Doctor[] | any[];
  extraParameter:ExtraParameter|string
  emergencyCall: string
  plans: string[] = []
  orgId:Number //Farmalink
  typeId:string //Farmalink
  farmalinkId:Number //Farmalink
  loginValidatorTextHeader:string
  loginValidatorTextFooter:string
  loginValidatorImage:string
  defaultValidators:string[]
  registrationSelectorImage:string
  prescriptionLogo:string
  appointmentMailLogo:string
  validatorName:string
  androidPackageName:string
  iosBundleId:string
  webUrl:string
  all:string
  active:string
  logged:string
  loggedAndActive:string
  prescriptionMedicinesModel:any[]
  webhookUrl: string //web hooks
  webhookFull: boolean
  webhookPrescriptionInfo:boolean
  appointmentBufferDuration: Number
  appointmentDuration: Number
  appointmentWaitingTolerance: Number
  emailAppointmentNotification:boolean
  smsAppointmentNotification:boolean
  deprecated:boolean
  useOwnVademecum:boolean
  clientAPIUrl: string
  supportsCustomQuestions: boolean
  satisfactionSurveyQuestions:any[]
  supportsManualCall: boolean
  reportSuspectedCovid: boolean
  prescriptionMail: string
  defaultPlan: Plan
  emailSessionCreation:boolean
  smsSessionCreation:boolean
  covidReportEmail: string
  ordersEmails: string
  prescriptionsEmails: string
  appointmentsBCCAddress: string
  useLadDoctors: boolean
  sendPrescriptionByWhatsApp: boolean
  sendOrderByWhatsApp: boolean
  sendMedicalCareRecordByWhatsApp: boolean
  supportedLanguages: any[]
  whatsappFirstContactMessage: string
  whatsappDischargeMessage: string
  title: string
  needsAdministrativeDischarge:boolean
  prescriptionIntegrationType:string
  useOwnTokenDuration: boolean
  ownTokenDuration: Number
  webhookClosedCase: boolean
  webhookClosedCaseDelay: Number
  checkSuccessfulCallDelay: Number
  loginNotificationEmails: string
  useLADBrandOnEmails: boolean
  whiteLabel: boolean
  sendClinicalHistoryToClaimAnalyst: boolean
  customStyleSheetUrl:string
  auth0CustomConnection: string
  authenticationType:string = 'none'
  usesBukeala:boolean
  supportsCOVIDMonitoring:boolean
  callBackgroundImage:string

    constructor(from?:Provider) {
        if(from) {
            this.id = from.id;
            this.name = from.name;
            this.serviceObjectName = from.serviceObjectName;
            this.auth0ConnectionName= from.auth0ConnectionName;
            this.updatedAt = from.updatedAt;
            this.language = from.language
            this.country = from.country
            this.timezone = from.timezone
            this.modelObjectName = from.modelObjectName
            this.billingEmailAddress = from.billingEmailAddress
            this.prescriptionModel = from.prescriptionModel
            this.prescriptionFooterModel = from.prescriptionFooterModel;
            this.prescriptionFooterColor = from.prescriptionFooterColor;
            this.prescriptionPillColor = from.prescriptionPillColor;
            this.assistanceCertificateModel = from.assistanceCertificateModel
            this.prescriptionModelMail = from.prescriptionModelMail
            this.requiresHealthInsuranceInformation = from.requiresHealthInsuranceInformation
            this.supportsPrescription = from.supportsPrescription
            this.supportsMedicalOrder = from.supportsMedicalOrder
            this.supportsMedicalCareRecord = from.supportsMedicalCareRecord
            this.fileSharing = from.fileSharing
            this.minAge = from.minAge
            this.emergencyCall = from.emergencyCall
            this.plans = from.plans ? from.plans : []
            this.orgId = from.orgId
            this.typeId = from.typeId
            this.farmalinkId = from.farmalinkId
            this.loginValidatorTextHeader = from.loginValidatorTextHeader
            this.loginValidatorTextFooter = from.loginValidatorTextFooter
            this.loginValidatorImage = from.loginValidatorImage
            this.defaultValidators = from.defaultValidators
            this.registrationSelectorImage = from.registrationSelectorImage
            this.prescriptionLogo = from.prescriptionLogo
            this.appointmentMailLogo = from.appointmentMailLogo
            this.validatorName = from.validatorName
            this.androidPackageName = from.androidPackageName
            this.iosBundleId = from.iosBundleId
            this.webUrl = from.webUrl,
            this.all = from.all,
            this.active = from.active,
            this.logged = from.logged,
            this.loggedAndActive = from.loggedAndActive,
            this.prescriptionMedicinesModel = from.prescriptionMedicinesModel
            this.webhookUrl = from.webhookUrl
            this.webhookFull = from.webhookFull
            this.webhookPrescriptionInfo = from.webhookPrescriptionInfo
            this.appointmentBufferDuration = from.appointmentBufferDuration
            this.appointmentDuration = from.appointmentDuration
            this.appointmentWaitingTolerance = from.appointmentWaitingTolerance
            this.emailAppointmentNotification = from.emailAppointmentNotification
            this.smsAppointmentNotification = from.smsAppointmentNotification
            this.emailSessionCreation = from.emailSessionCreation
            this.smsSessionCreation = from.smsSessionCreation
            this.deprecated = from.deprecated
            this.useOwnVademecum = from.useOwnVademecum
            this.clientAPIUrl = from.clientAPIUrl
            this.supportsCustomQuestions = from.supportsCustomQuestions
            this.satisfactionSurveyQuestions = from.satisfactionSurveyQuestions
            this.supportsManualCall = from.supportsManualCall
            this.reportSuspectedCovid = from.reportSuspectedCovid
            this.covidReportEmail = from.covidReportEmail
            this.prescriptionMail = from.prescriptionMail
            this.defaultPlan = from.defaultPlan
            this.useLadDoctors = from.useLadDoctors
            this.prescriptionsEmails = from.prescriptionsEmails;
            this.appointmentsBCCAddress = from.appointmentsBCCAddress;
            this.ordersEmails = from.ordersEmails;
            this.sendPrescriptionByWhatsApp = from.sendPrescriptionByWhatsApp
            this.sendOrderByWhatsApp = from.sendOrderByWhatsApp
            this.sendMedicalCareRecordByWhatsApp = from.sendMedicalCareRecordByWhatsApp
            this.supportedLanguages = from.supportedLanguages;
            this.whatsappFirstContactMessage = from.whatsappFirstContactMessage;
            this.title = from.title;
            this.needsAdministrativeDischarge = from.needsAdministrativeDischarge
            this.whatsappDischargeMessage = from.whatsappDischargeMessage,
            this.prescriptionIntegrationType = from.prescriptionIntegrationType
            this.whatsappDischargeMessage = from.whatsappDischargeMessage
            this.useOwnTokenDuration = from.useOwnTokenDuration;
            this.ownTokenDuration = from.ownTokenDuration;
            this.webhookClosedCase = from.webhookClosedCase;
            this.webhookClosedCaseDelay = from.webhookClosedCaseDelay;
            this.checkSuccessfulCallDelay = from.checkSuccessfulCallDelay;
            this.loginNotificationEmails = from.loginNotificationEmails;
            this.useLADBrandOnEmails = from.useLADBrandOnEmails;
            this.whiteLabel = from.whiteLabel;
            this.sendClinicalHistoryToClaimAnalyst = from.sendClinicalHistoryToClaimAnalyst;
            this.customStyleSheetUrl = from.customStyleSheetUrl;
            this.auth0CustomConnection = from.auth0CustomConnection;
            this.authenticationType = from.authenticationType || 'none';
            this.usesBukeala = from.usesBukeala;
            this.supportsCOVIDMonitoring = from.supportsCOVIDMonitoring;
            this.callBackgroundImage = from.callBackgroundImage;
        }
    }

    prescriptionCompleted():boolean{
        return (this.supportsPrescription && this.prescriptionModel!=null && this.prescriptionModelMail!=null)
    }

    missingPrescription():boolean{
        var result = this.supportsPrescription &&
       (
        !(this.prescriptionModel && this.prescriptionModelMail) //NAND
       )

        return result
    }

    assistanceCertificateCompleted():boolean{
        return (this.supportsMedicalCareRecord && this.assistanceCertificateModel!=null)
    }

    countMissingPrescriptionFields():Number{
        let count = 0
        count = (this.prescriptionModel!=null) ? 1 : 0
        count = (this.prescriptionModelMail!=null) ? count+1 : count
        return count
    }

    addPlan(plan:string){
        this.plans.push(plan)
    }

    removePlan(plan:string){
        console.log("antes de borrar",this.plans)
        console.log("Pos",this.plans.indexOf(plan))
        this.plans.splice(this.plans.indexOf(plan),1)
        console.log("Depues",this.plans)
    }
}



// WEBPACK FOOTER //
// ./src/app/classes/provider.ts